import { currencyFormatter } from 'components/movimentiTableRow/utils/utils';
import { useGetProfileContractQuery } from 'features/api/apiSlice';
import { useSendInfoMutation } from 'features/api/userSlice';
import { useInternalSession } from 'hooks/useInternalSession';
import format from 'date-fns/format';
import { useCallback } from 'react';
import { TIPOLOGY_SEND_INFO } from 'utility/dashboard/constants';
import { getAmount } from 'utility/functions';

type SendVoucherSmsParams = {
  idBigl: string;
  importo: string;
  textEmail: string;
  subjectMail: string;
  expirationDate: string;
  transactionDate: string;
};
export const useSendEmail = ({
  idBigl,
  importo,
  textEmail,
  subjectMail,
  expirationDate,
  transactionDate,
}: SendVoucherSmsParams) => {
  const {
    session: { user },
  } = useInternalSession();
  const [sendInfo] = useSendInfoMutation();
  const { data: profileContractResponse } = useGetProfileContractQuery(user?.csmfCod, {
    selectFromResult: (response) => ({
      ...response,
      data: {
        email: response.data?.email,
        fiscalCode: response.data?.cf,
      },
    }),
  });

  const sendEmail = useCallback(async () => {
    if (profileContractResponse) {
      {
        const emailHtmlContent = `"<html><head><title>${subjectMail}</title></head><body><font size=\"2\" face=\"Arial, Helvetica, sans-serif\">\n${textEmail
          ?.replace('{{ID_VOUCHER}}', idBigl ?? '')
          .replace('{{CONTRACT_CODE}}', user?.contractCode ?? '')
          .replace('{{FISCAL_CODE}}', profileContractResponse.fiscalCode ?? '')
          .replace('{{AMOUNT}}', currencyFormatter.format(getAmount(importo)))
          .replace('{{DATE}}', transactionDate)
          .replace('{{EXPIRE_DATE}}', expirationDate)}</font></body></html>\n`;

        await sendInfo({
          to: profileContractResponse.email!,
          text: emailHtmlContent,
          from: profileContractResponse.email!,
          subject: subjectMail,
          type: TIPOLOGY_SEND_INFO.EMAIL,
        });
      }
    }
  }, [
    profileContractResponse,
    subjectMail,
    textEmail,
    idBigl,
    user?.contractCode,
    importo,
    transactionDate,
    expirationDate,
    sendInfo,
  ]);

  return sendEmail;
};
